<template>
  <!-- BEGIN: Profile Info -->
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center">
      <h2 class="text-lg font-medium mr-auto">Planning Stock</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <div class="flex items-center mt-2 ml-2">
          <div class="mr-2 flex items-center">
            <input id="remember-me" type="checkbox" v-model="page_data.check"
              class="form-check-input border mr-2 bg-white" />
            <label for="remember-me" class="text-md font-medium">Manual</label>
          </div>
        </div>
        <div class="w-full flex sm:w-auto mt-3 ml-2">
          <div class="w-56 relative text-gray-700 dark:text-gray-300 mr-4">
            <input type="text" v-model="page_data.search" @change="getPacketDetailsScan" autofocus ref="focusMe"
              class="form-control w-56 box pr-10 placeholder-theme-13" placeholder="Scan Packet" />
            <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
          </div>
          <button class="btn btn-primary shadow-md mr-2" :disabled="page_data.check == false" @click="checkadd">Add</button>
        </div>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div>
        <div class="grid grid-cols-12 gap-5">
          <!-- <div class="col-span-12 md:col-span-12 lg:col-span-3 xl:col-span-2">
                        <h2 class="text-lg font-bold">Available Packets</h2>
                    </div> -->
          <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2">
            <div>
              <input id="tabulator-html-filter-value" v-model="filter_data.stock_no" type="text"
                class="form-control 2xl:w-full" placeholder="Stock No" />
            </div>
          </div>
          <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2">
            <div>
              <TomSelect v-model="filter_data.kapan_id" :options="{
                placeholder: 'Select Kapan',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Kapan'
                  }
                }
              }" class="w-full">
                <option value="0">Select Kapan</option>
                <option v-for="(item, index) in page_data.kapan_details" :key="index" :value="item.id">{{ item.lot_no }}
                  ({{
                    item.voucher_no }})</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2">
            <div>
              <TomSelect v-model="filter_data.packet_status" :options="{
                placeholder: 'Select Packet Status',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Packet Type'
                  }
                }
              }" class="w-full">
                <option value="0">Packet Status</option>
                <option value="pending_plan">Pending Plan</option>
                <option value="added_plan">Added Plan</option>
                <option value="final_plan">Final Plan</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2"
            v-if="[1, 2, 8].includes(user_details.user_role)">
            <div>
              <TomSelect v-model="filter_data.worker_type" :options="{
                placeholder: 'Worker Type',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Worker Type'
                  }
                }
              }" @change="get_party_details" class="w-full">
                <option disabled value="0">Worker Type</option>
                <option :value="1">Planner</option>
                <option :value="2">Checker</option>
                <option :value="3">Polish Party</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2"
            v-if="[1, 2, 8].includes(user_details.user_role)">
            <div>
              <TomSelect v-model="filter_data.party_id" :options="{
                placeholder: 'Select Worker',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Worker'
                  }
                }
              }" class="w-full">
                <option value="0">Select Worker</option>
                <option v-for="(item, index) in page_data.party_details" :key="index" :value="item.id">{{ item.firm_name
                  ? item.firm_name : (item.first_name + " " + item.last_name)
                  }}</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2">
            <div>
              <button class="btn btn-secondary mr-2" @click="resetFilters">
                Reset
              </button>
              <button class="btn btn-primary " @click="initTabulator">
                Generate
              </button>
            </div>
          </div>
          <div class="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-3">
            <div class="flex flex-wrap">

              <div class="text-sm font-bold mr-4">Total Stock: {{ page_data.total.total_packets ?
                page_data.total.total_packets : 0 }}</div>
              <!-- <div class="text-sm font-bold">Total WT(Ct): {{ page_data.total.total_weight ? $h.myFloat(page_data.total.total_weight) : 0 }} Ct</div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div id="tabulator" ref="tableRef" class="mt-5 table-report table-report--tabulator"></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->

    <planDetail ref="planDetailRef" @updatePlanDetails="updatePlanDetails" @SetImportDetails="SetImportDetails"
      @addNewPlanning="addNewPlanning" @focutScan="focutScan" />
    <planImport ref="planImportRef"  @getPacketPlans="getPacketPlans" />
    <newPlan ref="newPlanRef" @initTabulator="initTabulator" @getPacketPlans="getPacketPlans" />
  </div>
</template>
<script setup>
/* eslint-disable */
import { BASE_URL } from '@/constants/config'
import axios from 'axios'
import cash from 'cash-dom'
import { computed, inject, onMounted, provide, reactive, ref, toRef, watch } from 'vue'
// import print from 'vue3-print-nb'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import store from '@/store'
import planImport from '@/views/PacketTransaction/planner-multiple-issue/Modals/upload.vue'
import planDetail from '@/views/PacketTransaction/planner-multiple-issue/Modals/view.vue'
import newPlan from '@/views/PacketTransaction/planner-multiple-issue/Modals/add.vue'

const planImportRef = ref()
const planDetailRef = ref()
const newPlanRef = ref()

const user_details = computed(() => store.state.user.currentUser)
const dropzoneSingleRef = ref()
const page_data = reactive({
  search: '',
  check: false,
  waiting: false,
  loading: false,
  packet_details: [],
  cosing_value: 0,
  cosing_value_manager: 0,
  message: '',
  error: '',
  total_items: 1,
  pack_id: '',
  pack_code: '',
  pack_weight: '',
  plan_id: '',
  account_id: user_details.value.account_id,
  stone: '',
  base_url: BASE_URL,
  token: localStorage.getItem('token'),
  menual_total: {
    weight: 0,
    polish_weight: 0,
    value: 0,
  },
  plan_details: [],
  uploaded_fn: [],

  total: [],
  kapan_details: [],
  party_details: [],
})

const filter_data = reactive({
  kapan_id: '0',
  party_id: '0',
  worker_type: '0',
  stock_no: '',
  packet_type: '0',
  employee_id: '0',
  packet_status: '0',
})
const focusMe = ref()
const tableRef = ref()
const tabulator = ref()


function getPacketPlans(id) {

  planDetailRef.value.getPacketPlans(id)
}
function updatePlanDetails(data) {

  newPlanRef.value.updatePlanDetails(data)

}
const initTabulator = () => {

  let filter_params = {
    kapan_id: filter_data.kapan_id == '0' ? '' : window.btoa(filter_data.kapan_id),
    party_id: filter_data.party_id == '0' ? '' : window.btoa(filter_data.party_id),
    worker_type: filter_data.worker_type == '0' ? '' : window.btoa(filter_data.worker_type),
    stock_no: filter_data.stock_no == '' ? '' : window.btoa(filter_data.stock_no),
    packet_type: filter_data.packet_type == '0' ? '' : window.btoa(filter_data.packet_type),
    employee_id: filter_data.employee_id == '0' ? '' : window.btoa(filter_data.employee_id),
    packet_status: filter_data.packet_status == '0' ? '' : window.btoa(filter_data.packet_status)
  }

  if (tabulator.value) {
    tabulator.value.destroy()
    tabulator.value = null
  }

  if ([1, 2, 3, 8].includes(user_details.value.user_role)) {
    tabulator.value = new Tabulator(tableRef.value, {
      ajaxURL: BASE_URL + 'api/purchase/get_planning_available_packets',
      ajaxConfig: {
        method: "GET", //set request type to Position
        headers: {
          "Content-type": 'application/json; charset=utf-8', //set specific content type
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
      },
      ajaxParams: { ...filter_params, _t: Date.now() },
      ajaxFiltering: true,
      ajaxSorting: true,
      printAsHtml: true,
      printStyled: true,
      headerSort: false,
      pagination: 'remote',
      paginationSize: 20,
      paginationSizeSelector: [20, 30, 40],
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: 'Packet No',
          responsive: 0,

          field: 'number',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            const a = cash(`<div>
                  <div class="whitespace-nowrap">${cell.getData().urgent == 1 ? '<span class="text-theme-6">' + cell.getData().number + '</span>' : cell.getData().number
              }</div>
                </div>`)

            cash(a).on('click', function () {
              page_data.pack_code = cell.getData().number
              getPacketPlans(cell.getData().id)

            })
            return a[0]
          }
        },
        {
          title: 'Stock No',
          responsive: 0,
          field: 'vepari_no',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().vepari_no
              }</div>
                </div>`
          }
        },
        {
          title: 'Type',
          responsive: 0,
          field: 'type',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().type
              }</div>
                </div>`
          }
        },
        {
          title: 'Weight',
          responsive: 0,
          field: 'weight',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().weight
              }</div>
                </div>`
          }
        },
        {
          title: ' Current Weight',
          responsive: 0,
          field: 'cr_weight',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().cr_weight
              }</div>
                </div>`
          }
        },
        {
          title: 'Stn',
          field: 'stone_name',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false
        },
        {
          title: 'Est Planning',
          field: 'est_planning',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().owner_value ? parseFloat(parseFloat(cell.getData().owner_value) + (parseFloat(cell.getData().majuri_type == 1 ? (cell.getData().owner_value * cell.getData().majuri_rate / 100) : cell.getData().weight * cell.getData().majuri_rate)) + parseFloat(cell.getData().margin_percent * cell.getData().owner_value / 100)).toFixed(2) + ' $' : '-'
              }</div>
                </div>`
          }
        },
        {
          title: 'Total Plan',
          field: 'est_planning',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().total_plan ? cell.getData().total_plan : '-'
              }</div>
                </div>`
          }
        },
        {
          title: 'Per/Ct',
          field: 'owner_per_ct',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().owner_per_ct ? cell.getData().owner_per_ct : '-'
              }</div>
                </div>`
          }
        },
        {
          title: 'Total Amount',
          field: 'owner_value',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().owner_value ? cell.getData().owner_value : '-'
              }</div>
                </div>`
          }
        },
        {
          title: 'Final',
          field: 'final_plan_date',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {

            if(cell.getData().final_plan_date){

              return `<div class="btn btn-outline-success btn-sm p-1 m-1">
                    <i data-feather="check" class="w-4 h-4"></i>

                </div>`
            } else {
              return `<div class="btn btn-outline-danger btn-sm p-1 m-1">
                    <i data-feather="x" class="w-4 h-4"></i>

                </div>`
            }
          }
        },
        {
          title: 'Plans',
          field: '',
          hozAlign: 'center',
          vertAlign: 'middle',
          headerSort: false,
          print: false,
          download: false,
          columns: [
            {
              title: '',
              field: '',
              hozAlign: 'center',
              vertAlign: 'middle',
              headerSort: false,
              print: false,
              download: false,
              width: 100,
              formatter(cell) {
                if (((cell.getData().status == 2 && cell.getData().process_id != null && [3, 4, 5, 9, 11].includes(cell.getData().process_type)))) {
                  const a = cash(`<div class="flex lg:justify-center items-center">
                        <button class="btn btn-primary btn-sm flex items-center mr-3"> New Plan
                          </button>
                          </div>`)
                  cash(a).on('click', function () {
                    addNewPlanning(cell.getData())
                  })
                  return a[0]
                }
              }
            },
            {
              title: '',
              field: '',
              hozAlign: 'center',
              vertAlign: 'middle',
              headerSort: false,
              print: false,
              download: false,
              width: 100,
              formatter(cell) {
                if (((cell.getData().status == 2 && cell.getData().process_id != null && [3, 4, 5, 9, 11].includes(cell.getData().process_type)))) {

                  const a = cash(`<div class="flex lg:justify-center items-center">
                        <button class="btn btn-primary btn-sm flex items-center mr-3">Import
                        </button>
                      </div>`)
                  cash(a).on('click', function () {

                    planImportRef.value.show({

                      number: cell.getData().number,
                      vepari_no: cell.getData().vepari_no,
                      id: cell.getData().id
                    })

                  })
                  return a[0]
                }
              }
            },
            {
              title: '',
              field: '',
              hozAlign: 'center',
              vertAlign: 'middle',
              headerSort: false,
              print: false,
              download: false,
              width: 100,
              formatter(cell) {
                // if(((cell.getData().status == 2) || (cell.getData().pack_type == 1))) {
                const a = cash(`<div class="flex lg:justify-center items-center">
                        <button class="btn btn-success btn-sm flex items-center mr-3">
                          <i data-feather="check-square" class="w-4 h-4 mr-1"></i> View
                        </button>
                      </div>`)
                cash(a).on('click', function () {
                  planDetailRef.value.getPlnaDetails(cell.getData().id, cell.getData().number)

                })
                return a[0]
                // }
              }
            }
          ],
        },
      ],
      renderComplete() {
        feather.replace({
          'stroke-width': 1.5
        })
      }
    })

    let promise = axios({
      url: "api/purchase/planning_available_packets_total",
      method: "post",
      data: filter_params,
      baseURL: BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),

      },
      config: {
        headers: {
          Accept: "application/json"
        }
      }
    });
    return promise
      .then(result => result.data)
      .then(data => {
        page_data.total = data.total
      })
      .catch(_error => {
        page_data.total = []
      });
  } else if (user_details.value.user_role == 4 || user_details.value.user_role == 5 || user_details.value.user_role == 6) {
    tabulator.value = new Tabulator(tableRef.value, {
      ajaxURL: BASE_URL + 'api/purchase/get_available_packets',
      ajaxConfig: {
        method: "GET", //set request type to Position
        headers: {
          "Content-type": 'application/json; charset=utf-8', //set specific content type
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
      },
      ajaxParams: { ...filter_params, _t: Date.now() },
      ajaxFiltering: true,
      ajaxSorting: true,
      printAsHtml: true,
      printStyled: true,
      headerSort: false,
      pagination: 'remote',
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: 'Packet No',
          responsive: 0,

          field: 'number',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            const a = cash(`<div>
                  <div class="whitespace-nowrap">${cell.getData().urgent == 1 ? '<span class="text-theme-6">' + cell.getData().number + '</span>' : cell.getData().number
              }</div>
                </div>`)


            cash(a).on('click', function () {
              page_data.pack_code = cell.getData().number
              getPacketPlans(cell.getData().id)

            })
            return a[0]
          }
        },
        {
          title: 'Stock No',
          responsive: 0,
          field: 'vepari_no',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().vepari_no
              }</div>
                </div>`
          }
        },
        {
          title: 'Type',
          responsive: 0,
          field: 'type',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().type
              }</div>
                </div>`
          }
        },
        {
          title: 'Weight',
          responsive: 0,
          field: 'weight',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().weight
              }</div>
                </div>`
          }
        },
        {
          title: ' Current Weight',
          responsive: 0,
          field: 'cr_weight',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().cr_weight
              }</div>
                </div>`
          }
        },
        {
          title: 'Stn',
          field: 'stone_name',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false
        },
        {
          title: 'Est Planning',
          field: 'est_planning',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().owner_value ? parseFloat(parseFloat(cell.getData().owner_value) + parseFloat(cell.getData().majuri_type == 1 ? (cell.getData().owner_value * cell.getData().majuri_rate / 100) : cell.getData().weight * cell.getData().majuri_rate) + parseFloat(cell.getData().margin_percent * cell.getData().owner_value / 100)).toFixed(2) + ' $' : '-'
              }</div>
                </div>`
          }
        },
        {
          title: 'Total Plan',
          field: 'est_planning',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                  <div class="whitespace-nowrap">${cell.getData().total_plan ? cell.getData().total_plan : '-'
              }</div>
                </div>`
          }
        },
        {
          title: 'Plans',
          field: '',
          hozAlign: 'center',
          vertAlign: 'middle',
          headerSort: false,
          print: false,
          download: false,
          columns: [
            {
              title: '',
              field: '',
              hozAlign: 'center',
              vertAlign: 'middle',
              headerSort: false,
              print: false,
              download: false,
              width: 100,
              formatter(cell) {
                if (cell.getData().process_id != null && [3, 4, 5, 9, 11].includes(cell.getData().process_type) && cell.getData().employee_id == user_details.value.account_id && cell.getData().employee_role == user_details.value.user_role && cell.getData().status == 2) {
                  // if (cell.getData().process_id != null && [3, 4, 5, 9, 11].includes(cell.getData().process_type) && cell.getData().employee_id == user_details.value.account_id && cell.getData().employee_role == user_details.value.user_role && cell.getData().status == 2) {

                  const a = cash(`<div class="flex lg:justify-center items-center">
                        <button class="btn btn-primary btn-sm flex items-center mr-3"> New Plan
                          </button>
                          </div>`)
                  cash(a).on('click', function () {
                    addNewPlanning(cell.getData())
                  })
                  return a[0]
                }
              }
            },
            {
              title: '',
              field: '',
              hozAlign: 'center',
              vertAlign: 'middle',
              headerSort: false,
              print: false,
              download: false,
              width: 100,
              formatter(cell) {
                if (cell.getData().process_id != null && [3, 4, 5, 9, 11].includes(cell.getData().process_type) && cell.getData().employee_id == user_details.value.account_id && cell.getData().employee_role == user_details.value.user_role && cell.getData().status == 2) {
                  // if (cell.getData().process_id != null && [3, 4, 5, 9, 11].includes(cell.getData().process_type) && cell.getData().employee_id == user_details.value.account_id && cell.getData().employee_role == user_details.value.user_role && cell.getData().status == 2) {

                  const a = cash(`<div class="flex lg:justify-center items-center">
                        <button class="btn btn-primary btn-sm flex items-center mr-3">Import
                        </button>
                      </div>`)
                  cash(a).on('click', function () {
                    planImportRef.value.show({

                      number: cell.getData().number,
                      vepari_no: cell.getData().vepari_no,
                      id: cell.getData().id
                    })

                  })
                  return a[0]
                }
              }
            },
            {
              title: '',
              field: '',
              hozAlign: 'center',
              vertAlign: 'middle',
              headerSort: false,
              print: false,
              download: false,
              width: 100,
              formatter(cell) {
                const a = cash(`<div class="flex lg:justify-center items-center">
                        <button class="btn btn-success btn-sm flex items-center mr-3">
                          <i data-feather="check-square" class="w-4 h-4 mr-1"></i> View
                        </button>
                      </div>`)
                cash(a).on('click', function () {
                  planDetailRef.value.getPlnaDetails(cell.getData().id, cell.getData().number)

                })
                return a[0]
              }
            }
          ],
        },
      ],
      renderComplete() {
        feather.replace({
          'stroke-width': 1.5
        })
      }
    })

    let promise = axios({
      url: "api/purchase/available_packets_total",
      method: "post",
      data: filter_params,
      baseURL: BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),

      },
      config: {
        headers: {
          Accept: "application/json"
        }
      }
    });
    return promise
      .then(result => result.data)
      .then(data => {
        page_data.total = data.total
      })
      .catch(_error => {
        page_data.total = []
      });
  }

}
function addNewPlanning(item) {

  // console.log(item)
  newPlanRef.value.addNewPlanning(item)
}



const getLotDetails = () => {
  axios({
    url: 'api/master/dp_lot_details',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.kapan_details = res.data.items
  })
}
function checkadd() {
  if (page_data.search) {
    planDetailRef.value.checkadd(page_data.search)
  }
}

const focutScan = (value) => {
  page_data.search = ''

  if (value == true) {
    focusMe.value.focus()
  }
}

const get_party_details = () => {
  filter_data.party_id = '0'
  const params = {
    process_types: [5, 9, 11],
    worker_type: (filter_data.worker_type == '0' ? '' : filter_data.worker_type),
  }

  axios({
    url: 'api/master/get_jober_details_by_process',
    method: 'post',
    baseURL: BASE_URL,
    data: params,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.party_details = res.data.items
  }).catch((err) => {
    page_data.party_details = []
  })

}


const SetImportDetails = (data) => {

  planImportRef.value.show({

    number: data.number,
    vepari_no: data.vepari_no,
    id: data.id
  });
}
function getPacketDetailsScan() {
  if (!page_data.check && page_data.search) {
    checkadd();
  }
}

const resetFilters = () => {
  filter_data.kapan_id = '0'
  filter_data.party_id = '0'
  filter_data.worker_type = '0'
  filter_data.stock_no = ''
  filter_data.packet_type = '0'
  filter_data.employee_id = '0'
  filter_data.packet_status = '0'

  initTabulator()
}


onMounted(() => {
  initTabulator()
  getLotDetails()
  focusMe.value.focus()
})
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.input-group .input-group-text-custom {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(226, 232, 240, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(247, 250, 252, var(--tw-bg-opacity));
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgba(113, 128, 150, var(--tw-text-opacity));
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
</style>
